"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_list_store_1 = require("owa-mail-list-store");
var pinConversations_1 = require("./pinConversations");
var pinItems_1 = require("./pinItems");
/**
 * Toggle the isPinned value of the rows
 * @param rowKeys to be pinned/unpinned
 * @param tableViewId the table view id
 * @param isPinnedToSet the isPinned value to be set
 * @param actionSource the action source
 */
function markRowsPinnedUnpinned(rowKeys, tableViewId, isPinnedToSet, actionSource) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            pinConversations_1.default(rowKeys, tableView, isPinnedToSet, actionSource);
            break;
        case 1 /* Message */:
            pinItems_1.default(rowKeys, tableView, isPinnedToSet, actionSource);
            break;
    }
}
exports.default = markRowsPinnedUnpinned;
//# sourceMappingURL=markRowsPinnedUnpinned.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/markRowsPinnedUnpinned.js
// module id = 5609
// module chunks = 62